// Local Host Setup

// import axios from "axios";
// export const http = axios.create({ baseURL: "http://localhost:5009/" });
// export const barcode = "http://localhost:5009/images/barcodes/";
// export const server = "http://localhost:5009/";
// export const serverSocket = "http://localhost:5009/";
// export const apiUrlPatients = "http://localhost:5009/prijem/pacijenti/";
// export const apiUrlUputnice = "http://localhost:5009/prijem/uputnice/";
// export const apiUrlObradaPregled = "http://localhost:5009/obrada/pregled/";
// export const apiUrlNalaziPregled = "http://localhost:5009/nalazi/pregled";
// export const apiUrlNalaziOutbox = "http://localhost:5009/nalazi/outbox";
// export const apiUrlLabAssays = "http://localhost:5009/assays/lab";
// export const apiUrlAnaAssays = "http://localhost:5009/assays/ana";
// export const apiUrlControlClone = "http://localhost:5009/control/clone";
// export const apiUrlControlEdit = "http://localhost:5009/control/edit";
// export const apiUrlControlResults = "http://localhost:5009/control/results";
// export const apiUrlIntegration = "http://localhost:5009/api/pregled";
// export const apiUrlProdukt = "http://localhost:5009/inventar/produkti";
// export const apiUrlUgovor = "http://localhost:5009/inventar/ugovori";
// export const apiUrlStanje = "http://localhost:5009/inventar/stanje";
// export const apiUrlNarudzbenica = "http://localhost:5009/inventar/narudzbenice";
// export const apiUrlUlaz = "http://localhost:5009/inventar/ulazpregled";
// export const apiUrlIzlaz = "http://localhost:5009/inventar/izlazpregled";

// Client Setup - BH Telecom

import axios from "axios";
export const http = axios.create({ baseURL: "https://intermed.ilab.ba/" });
export const barcode = "https://intermed.ilab.ba/images/barcodes/";
export const server = "https://intermed.ilab.ba/";
export const serverSocket = "https://intermed.ilab.ba/";
export const apiUrlPatients = "https://intermed.ilab.ba/prijem/pacijenti/";
export const apiUrlUputnice = "https://intermed.ilab.ba/prijem/uputnice/";
export const apiUrlObradaPregled = "https://intermed.ilab.ba/obrada/pregled/";
export const apiUrlNalaziPregled = "https://intermed.ilab.ba/nalazi/pregled";
export const apiUrlNalaziOutbox = "https://intermed.ilab.ba/nalazi/outbox";
export const apiUrlLabAssays = "https://intermed.ilab.ba/assays/lab";
export const apiUrlAnaAssays = "https://intermed.ilab.ba/assays/ana";
export const apiUrlControlClone = "https://intermed.ilab.ba/control/clone";
export const apiUrlControlEdit = "https://intermed.ilab.ba/control/edit";
export const apiUrlControlResults = "https://intermed.ilab.ba/control/results";
export const apiUrlIntegration = "https://intermed.ilab.ba/api/pregled";
export const apiUrlProdukt = "https://intermed.ilab.ba/inventar/produkti";
export const apiUrlUgovor = "https://intermed.ilab.ba/inventar/ugovori";
export const apiUrlStanje = "https://intermed.ilab.ba/inventar/stanje";
export const apiUrlNarudzbenica = "https://intermed.ilab.ba/inventar/narudzbenice";
export const apiUrlUlaz = "https://intermed.ilab.ba/inventar/ulazpregled";
export const apiUrlIzlaz = "https://intermed.ilab.ba/inventar/izlazpregled";


//////////////////
// WEBPACK FOOTER
// ./config/config.js
// module id = 1wn0
// module chunks = 119